import React from 'react';
import SinResultados from '../sinResultados/SinResultados';
import CardResults from './cardResults';

/**
 * Componente que muestra los resultados de una búsqueda.
 * Si no hay resultados, muestra un mensaje amigable al usuario.
 * Si hay resultados, renderiza una lista de tarjetas.
 *
 * @param {Object} props
 * @param {Object} props.data - Objeto que contiene los resultados (`hits`) de la búsqueda.
 * @param {string} props.query - Término de búsqueda utilizado por el usuario.
 * @returns {JSX.Element} Resultado de la búsqueda o mensaje de "sin resultados".
 */
export default function Resultados({ data, query }) {
  const hits =  data && Array.isArray(data.hits) ? data.hits : [];

  return hits.length === 0
    ? <SinResultados query={query} />
    : <CardResults data={hits} />;
}